/**
 * Creates the normalized passport object expected by the shared passport component.
 */
export const defaultPassport = () => ({
  documentType: null,
  series: '',
  number: '',
  issueDate: '',
  subdivisionCode: '',
  issuedBy: ''
})

/**
 * Creates the normalized address object expected by the shared address component.
 */
export const defaultAddress = () => ({
  value: '',
  data: {},
  manual_input: false
})

/**
 * Creates an empty payer card. localId is used only as a stable Vue key.
 */
export const defaultPayer = () => ({
  localId: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
  representative: null,
  lastname: '',
  firstname: '',
  patronymic: '',
  gender: '',
  snils: '',
  birthDate: '',
  birthPlace: '',
  email: '',
  phone: '+7',
  citizenshipType: null,
  citizenship: null,
  passport: defaultPassport(),
  registrationAddress: defaultAddress(),
  actualAddress: defaultAddress()
})

/**
 * Creates the previous education institution address block.
 */
export const defaultEducationInstitutionAddress = () => ({
  country: '',
  region: '',
  district: '',
  locality: '',
  institutionName: ''
})

/**
 * Converts accepted documents loaded as either a JSON object or sparse array
 * to the document-id map used by the form.
 */
export const normalizeAcceptedDocuments = documents => {
  if (!documents || typeof documents !== 'object') {
    return {}
  }

  return Object.entries(documents).reduce((result, [documentId, documentData]) => {
    if (
      Number(documentId) > 0 &&
      documentData &&
      typeof documentData === 'object' &&
      !Array.isArray(documentData)
    ) {
      result[String(documentId)] = { ...documentData }
    }

    return result
  }, {})
}

/**
 * Creates a full empty application form model.
 */
export const defaultForm = () => ({
  lastname: '',
  firstname: '',
  patronymic: '',
  gender: '',
  snils: '',
  birthDate: '',
  birthPlace: '',
  email: '',
  phone: '+7',
  citizenshipType: '1',
  citizenship: 'RU',
  submittedViaEpgu: false,
  eserviceNumber: '',
  socialStatus: 0,
  passport: {
    ...defaultPassport(),
    documentType: '21'
  },
  registrationAddress: defaultAddress(),
  actualAddress: defaultAddress(),
  educationBase: '',
  previousEducationLevel: null,
  foreignEducationInstitution: false,
  graduationYear: '',
  certificateReceivedDate: '',
  educationInstitutionAddress: defaultEducationInstitutionAddress(),
  educationDocumentId: null,
  educationDocumentSeries: '',
  educationDocumentNumber: '',
  certificateWithHonors: false,
  certificateAverage: '',
  payers: [defaultPayer()],
  selectedSubjects: [],
  subjectGrades: {},
  selectedGiaSubjects: [],
  giaResults: {},
  targetOrganizationId: null,
  isGroupReplenishment: false,
  dormitoryNeed: null,
  privileges: [],
  schoolLanguages: [],
  workPlace: '',
  position: '',
  experience: '',
  militaryOfficeId: null,
  militaryOffice: '',
  notes: '',
  operatorComment: '',
  acceptedDocuments: {},
  documentsScan: [],
  approved: false,
  originalsAccepted: false,
  selectedContests: []
})
